import { Component, Input } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { addSegmentToList, initializeUserSegmentArray } from "@ponder-features/header/navbar/navbar.component";
import { LoadingComponent } from "@ponder-shared/loading/loading.component";
import { AuthService } from "@ponder-core/auth/auth.service";
import { CollectionPreviewsComponent } from "../profile/collection-previews.component";
import { SvgIcon, SvgIconMap } from "@ponder-shared/utils/svgIcons";
import { AuthSession } from "@ponder-core/auth/auth-session";
import { PonderDataClient } from "@apiserver-rest/ponder-data-client";
import { GetUserResourceVisibilityResponse, UserProtectedResource } from "@apiserver-rest/ponder-data-client-base";
import { take } from "rxjs";

@Component({
    selector: "collection",
    imports: [LoadingComponent, CollectionPreviewsComponent],
    templateUrl: "./user-collection.component.html"
})
export class UserCollectionComponent {
    @Input() public username!: string;
    public isOwnCollection: boolean = false;
    public isVisible?: boolean = undefined;

    public readonly importSvgIcon: string = SvgIconMap.get(SvgIcon.Import)!;
    public readonly exportSvgIcon: string = SvgIconMap.get(SvgIcon.Export)!;
    
    public constructor(
        private pageTitle: Title,
        private events: EventBroker,
        private ponderDataClient: PonderDataClient,
        private auth: AuthService) { }

    public ngOnInit() {
        this.pageTitle.setTitle(`Ponder > ${this.username} > Collection`);

        this.auth.getSessionAsync().then((authSession?: AuthSession) => {
            if (authSession?.username && (authSession.username == this.username)) {
                this.isOwnCollection = true;
                this.isVisible = true;
            } else {
                this.ponderDataClient
                    .userResourceVisibility(this.username, UserProtectedResource.Collection)
                    .pipe(take(1))
                    .subscribe({
                        next: (response: GetUserResourceVisibilityResponse) => {
                            if (response.success && response.isVisible) {
                                this.isVisible = true;
                            }
                        }
                    })
                    .add(() => { 
                        if (this.isVisible == undefined) {
                            this.isVisible = false;
                        }
                    });
            }
        });

        this.sendNavbarUpdate();
    }

    private sendNavbarUpdate(): void {
        var segments = initializeUserSegmentArray(this.username);
        addSegmentToList(segments, "Collection", "Collection");
        
        this.events.ui.navbarUpdateEvent.emit(segments);
    }
}